import React, { useState, useRef, useEffect} from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import './shapp_p1.css';
import './software.css';
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { geometrieConfig } from "./components_software/tipologia_punte_cpt";
import { MapComponent_sw} from './components/MapComponent_sw';



function SondaggioElabPanel() {
    const navigate = useNavigate();
     // ricezione dati da dataabase per modifica geometria esistente
    const location = useLocation();
    const incomingData = location.state;

    //compoenente mappa per archiviazione
    const mapRef = useRef(null);
    const [isMapClickActive, setIsMapClickActive] = useState(false);
    const toggleMapClick = () => {setIsMapClickActive(prev => !prev);};
    const handleProjectChange = (e) => {
        setSelectedProject(e.target.value);
        mapRef.current?.handleProjectChange(e);  // chiama MapComponent
      };
    // Ottieni i progetti quando il componente si monta
    useEffect(() => {
      const loadProjects = async () => {
        if (mapRef.current) {
          try {
            const projs = await mapRef.current.fetchProjects();
            setProjects(projs); // aggiorna la lista dei progetti
          } catch (err) {
            console.error("Errore caricamento progetti:", err);
          }
        }
      };
      // Polling finché mapRef.current non è pronto
      const interval = setInterval(() => {
        if (mapRef.current) {
          loadProjects();
          clearInterval(interval);
        }
      }, 100);
      return () => clearInterval(interval);
    }, []);
    
    const [projects, setProjects] = useState([]);
    const [selectedProject, setSelectedProject] = useState('');
    //riceve coordinate
    const [coordinate, setCoordinate] = useState("");
    const handleReceiveCoordinate = (coord) => {
        setCoordinate(coord); // aggiorna campo input solo al submit
      };
    // Stati principali
    const [selectedMenu, setSelectedMenu] = useState('anagrafica');
    const [activePanel, setActivePanel] = useState("report");
    //dati generali
    const [sonda, setSonda] = useState("");
    const [tipologia, setTipologia] = useState("");
    const [carotiere, setCarotiere] = useState("");
    const [rivestimento, setRivestimento] = useState("");
    const [profMax, setProfMax] = useState("");
    const [falda, setFalda] = useState("");
    const faldaPx =
      falda === "" || falda === null || falda === undefined
        ? null
        : Number(falda) * 40;
    const [qpc, setqpc] = useState(0);
    const [qbf, setqbf] = useState("");
    const [qpz, setqpz] = useState("");
    const [note, setnote] = useState("");
    //dati prova
    const [nomeProva, setNomeProva] = useState("");
    const tipoProva='SONDAGGIO'
    const [committente, setCommittente] = useState("");
    const [localita, setLocalita] = useState("");
    const [indirizzo, setIndirizzo] = useState("");
    const [dittes, setdittes] = useState("");
    const [op, setop] = useState("");
    //dati sondaggio
    const [fessurazione, setFessurazione] = useState({inizio: "",fine: ""});
    const [fessurazioni, setFessurazioni] = useState([]);
    //pokettest e torvain, spt
    const [pocketTests, setPocketTests] = useState([]);
    const [torvaneTests, setTorvaneTests] = useState([]);
    const [sptTests, setSptTests] = useState([]);
    const [campioni, setCampioni] = useState([]);

    const fileInputRef = useRef(null);
    const [taskId, setTaskId] = useState(null);
    const [loading, setLoading] = useState(false);
    const [loadingelab, setLoadingelab] = useState(false);
    const [result, setResult] = useState(null);


    //modal cancella riga
    const deleteRow = (index) => {
      setAnalisiData(prev => prev.filter((_, i) => i !== index));
    };

    //fessurazioni piezometro
    const addFessurazione = () => {
      setFessurazioni(prev => [
        ...prev,
        {
          id: Date.now(),
          inizio: "",
          fine: ""
        }
      ]);
    };
    const removeFessurazione = (id) => {
      setFessurazioni(prev =>
        prev.filter(item => item.id !== id)
      );
    };

    //add and remove poket test and torvain
    const addPocketTest = () => {
      setPocketTests(prev => [
        ...prev,
        { id: Date.now(), valore: "", profondita: "" }
      ]);
    };

    const removePocketTest = (id) => {
      setPocketTests(prev => prev.filter(item => item.id !== id));
    };

    const addTorvaneTest = () => {
      setTorvaneTests(prev => [
        ...prev,
        { id: Date.now(), valore: "", profondita: "" }
      ]);
    };

    const removeTorvaneTest = (id) => {
      setTorvaneTests(prev => prev.filter(item => item.id !== id));
    };

    const addSptTest = () => {
      setSptTests(prev => [
        ...prev,
        { id: Date.now(), valore: "", profondita: "" }
      ]);
    };

    const removeSptTest = (id) => {
      setSptTests(prev => prev.filter(item => item.id !== id));
    };

    const addCampione = () => {
      setCampioni(prev => [
        ...prev,
        {
          id: Date.now(),
          tipologia: "",
          qualita: "",
          profondita: "",
          campionatore: ""

        }
      ]);
    };

    const removeCampione = (id) => {
      setCampioni(prev => prev.filter(item => item.id !== id));
    };

    //costruzione stratigrafia
    const handleAddRow = () => {
      setAnalisiData(prev => [
        ...prev,
        {
          N: prev.length + 1,
          spessore: "",
          spessore: "",
          colore: "",
          texture: "",
          descrizione: "",
        }
      ]);
    };

    //team condivisione prove
    const [teams, setTeams] = useState([]);
    const [selectedTeam, setSelectedTeam] = useState(null);
      // Carica dati iniziali
    useEffect(() => {
        fetchTeams();
    }, []);
    const fetchTeams = async () => {
      const token = localStorage.getItem("token");
      try {
        const res = await axios.get("https://www.hat.sofhare.com/elaborazioni/teams/", {
          headers: { Authorization: `Bearer ${token}` },
        });
        setTeams(res.data);
      } catch (err) {
        toast.error("Errore caricamento team!", { autoClose: 2000 });
      }
    };
    //archiviazione

    const [formDatach, setFormDatach] = useState({
      tipo_prova: "",
      committente: "",
      luogo: "",
      indirizzo: "",
      nome_prova: "",
      stratigraphy_data: {},
      note: "",
      param_data:{},
    });

    const [openColorIndex, setOpenColorIndex] = useState(null);
    const toggleColorMenu = (i) => {
      setOpenColorIndex(openColorIndex === i ? null : i);
    };
    const [openTextureIndex, setOpenTextureIndex] = useState(null);
    const toggleTextureMenu = (i) => {
      setOpenTextureIndex(prev => (prev === i ? null : i));
    };

    let depthCursor = 0;


    const colors = [
      // =========================
      // BIANCHI / NEUTRI
      // =========================
      "#ffffff", "#f8f8f8", "#eeeeee", "#dddddd", "#cccccc",
      // =========================
      // NERI / GRIGI
      // =========================
      "#000000", "#1a1a1a", "#333333", "#4d4d4d", "#666666", "#808080", "#999999", "#b3b3b3",
      // =========================
      // SABBIE (giallo-beige)
      // =========================
      "#fff8dc", "#f5f5dc", "#f0e68c", "#e6d8ad", "#deb887",
      "#d2b48c", "#c2b280", "#c19a6b", "#bfa46f", "#a68a64",
      // =========================
      // ARGILLE (rosso-bruno)
      // =========================
      "#8b4513", "#a0522d", "#b5651d", "#cd853f", "#d2691e",
      "#a52a2a", "#b22222", "#8b0000", "#7a3b2e", "#6b2e1f",
      // =========================
      // LIMI (verdi/grigi/oliva)
      // =========================
      "#808000", "#6b8e23", "#9acd32", "#556b2f", "#2e8b57",
      "#3cb371", "#66cdaa", "#8fbc8f", "#708238", "#556b2f",
      // =========================
      // GHIAIE / ROCCE
      // =========================
      "#696969", "#778899", "#708090", "#2f4f4f", "#a9a9a9",
      "#d3d3d3", "#c0c0c0", "#b0c4de", "#a0a0a0", "#8f8f8f",
      // =========================
      // ACQUA / FALDA
      // =========================
      "#00ced1", "#40e0d0", "#48d1cc", "#5f9ea0", "#4682b4",
      "#1e90ff", "#4169e1", "#0000ff", "#00008b", "#191970",
      // =========================
      // COLORI ACCENTI (WARNING / STRUTTURALI)
      // =========================
      "#ff0000", "#ff4500", "#ff6347", "#ff7f50", "#ffa500",
      "#ffd700", "#ffff00", "#adff2f", "#00ff00", "#32cd32",
      "#00fa9a", "#00ff7f", "#7fff00", "#7cfc00",
      // =========================
      // VIOLA / LAVANDA (per marker tecnici)
      // =========================
      "#8a2be2", "#9400d3", "#9932cc", "#ba55d3", "#da70d6",
      "#ee82ee", "#dda0dd", "#d8bfd8",
      // =========================
      // ROSA / MARCATURA
      // =========================
      "#ff1493", "#ff69b4", "#ffb6c1", "#ffc0cb", "#db7093",
      // =========================
      // EXTRA GEO TECNICI
      // =========================
      "#2c3e50", "#34495e", "#7f8c8d", "#95a5a6", "#bdc3c7"
    ];

    // =========================
    // TEXTURE LIST
    // =========================
    const textures = [
      "none",
      // SABBIE
      "dots_fine",
      "dots_medium",
      "dots_coarse",
      "sand_mix",
      "dots_fine_hollow",
      "dots_medium_hollow",
      // GHIAIE
      "gravel_small",
      "gravel_medium",
      "gravel_large",
      // LIMI / LINEE
      "lines_fine",
      "silt_lines_fine",
      "silt_lines_coarse",
      "organic",
      "grid_vertical",
      "lines_diagonal",
      // ROCCIA
      "fractured",
      "crosshatch",
      // TECNICHE
      "grid",
    ];


    // =========================
    // TEXTURE GENERATOR
    // =========================
    const getTexture = (type) => {
      const g = (value) => value.trim();

      switch (type) {

        // =========================
        // DOTS
        // =========================
        case "dots_fine":
          return g(`
            radial-gradient(circle, #000 0.8px, transparent 0.9px)
          `);

        case "dots_medium":
          return g(`
            radial-gradient(circle, #000 1.5px, transparent 1.8px)
          `);

        case "dots_coarse":
          return g(`
            radial-gradient(circle, #000 2.5px, transparent 2.8px)
          `);

        case "sand_mix":
          return g(`
            radial-gradient(circle at 2px 2px, #000 0.8px, transparent 1px),
            radial-gradient(circle at 10px 6px, #000 1.2px, transparent 1.4px),
            radial-gradient(circle at 16px 12px, #000 0.7px, transparent 1px)
          `);

        // =========================
        // HOLLOW DOTS
        // =========================
        case "dots_fine_hollow":
          return g(`
            radial-gradient(circle, transparent 0.6px, #000 1.4px, transparent 2px)
          `);

        case "dots_medium_hollow":
          return g(`
            radial-gradient(circle, transparent 0.8px, #000 2px, transparent 2.6px)
          `);

        // =========================
        // GHIAIA
        // =========================
        case "gravel_small":
          return g(`
            radial-gradient(circle at 6px 6px, #333 2px, transparent 2.2px),
            radial-gradient(circle at 18px 10px, #333 1.5px, transparent 2px),
            radial-gradient(circle at 10px 20px, #333 2px, transparent 2.2px)
          `);

        case "gravel_medium":
          return g(`
            radial-gradient(circle at 8px 6px, #333 3px, transparent 3.2px),
            radial-gradient(circle at 22px 12px, #333 2.5px, transparent 2.8px),
            radial-gradient(circle at 14px 26px, #333 2.8px, transparent 3px)
          `);

        case "gravel_large":
          return g(`
            radial-gradient(circle at 10px 8px, #333 4px, transparent 4.2px),
            radial-gradient(circle at 30px 18px, #333 3.5px, transparent 3.8px),
            radial-gradient(circle at 18px 34px, #333 4px, transparent 4.3px)
          `);

        // =========================
        // LINEE ORIZZONTALI
        // =========================
        case "lines_fine":
          return g(`
            repeating-linear-gradient(
              0deg,
              #000 0px,
              #000 1.5px,
              transparent 1.5px,
              transparent 6px
            )
          `);

        case "silt_lines_fine":
          return g(`
            repeating-linear-gradient(
              0deg,
              #000 0px,
              #000 3px,
              transparent 3px,
              transparent 10px
            )
          `);

        case "silt_lines_coarse":
          return g(`
            repeating-linear-gradient(
              0deg,
              #000 0px,
              #000 1px,
              transparent 1px,
              transparent 16px
            )
          `);

        case "organic":
          return g(`
            repeating-linear-gradient(
              0deg,
              #111 0px,
              #111 1px,
              transparent 1px,
              transparent 12px
            ),
            radial-gradient(circle, #111 1px, transparent 1.2px)
          `);

        // =========================
        // VERTICALI
        // =========================
        case "grid_vertical":
          return g(`
            repeating-linear-gradient(
              90deg,
              #000 0px,
              #000 1px,
              transparent 1px,
              transparent 8px
            )
          `);

        // =========================
        // DIAGONALI
        // =========================
        case "lines_diagonal":
          return g(`
            repeating-linear-gradient(
              45deg,
              #000 0px,
              #000 1px,
              transparent 1px,
              transparent 8px
            )
          `);

        case "fractured":
          return g(`
            repeating-linear-gradient(
              135deg,
              #000 0px,
              #000 1px,
              transparent 1px,
              transparent 10px
            )
          `);

        // =========================
        // CROSSHATCH
        // =========================
        case "crosshatch":
          return g(`
            repeating-linear-gradient(45deg, #000 0px, #000 1px, transparent 1px, transparent 8px),
            repeating-linear-gradient(-45deg, #000 0px, #000 1px, transparent 1px, transparent 8px)
          `);

        // =========================
        // GRID
        // =========================
        case "grid":
          return g(`
            repeating-linear-gradient(0deg, #000 0px, #000 1px, transparent 1px, transparent 10px),
            repeating-linear-gradient(90deg, #000 0px, #000 1px, transparent 1px, transparent 10px)
          `);

        default:
          return "none";
      }
    };

    // =========================
    // STYLE HELPER
    // =========================
    const getTextureStyle = (type) => {
      if (!type || type === "none") {
        return {
          background: "none"
        };
      }

      const isDotOrPattern =
        type.includes("dots") ||
        type.includes("gravel") ||
        type.includes("sand") ||
        type.includes("lines");

      return {
        backgroundImage: getTexture(type),
        backgroundRepeat: "repeat",
        backgroundSize: isDotOrPattern ? "16px 16px" : "auto",
        backgroundColor: "#f5f0e0"
      };
    };


    const getTextureSize = (type) => {
          const sizes = {
            dots_fine: "16px 16px",
            dots_medium: "20px 20px",
            dots_coarse: "24px 24px",
            sand_mix: "20px 20px",
            dots_fine_hollow: "16px 16px",
            dots_medium_hollow: "20px 20px",
            gravel_small: "30px 30px",
            gravel_medium: "36px 36px",
            gravel_large: "44px 44px",
            lines_fine: "12px 12px",
            lines_diagonal: "16px 16px"
          };
          return sizes[type] || "20px 20px";
        };


    //salvataggio report
    function printReport() {
      window.print();
    }

    //id geometria se da database
    const [idgeom, setidgeom] = useState(null);

    //tabella compilazione sondaggio
    const [analisiData, setAnalisiData] = useState(
      Array.from({ length: 20 }, (_, i) => ({
        N: i + 1,
        spessore: "",
        colore: "",
        texture: "",
        descrizione: "",
      }))
    );

    const layers = analisiData
      .filter(r => r.spessore > 0)
      .map(r => {
        const layer = {
          ...r,
          top: depthCursor,
          bottom: depthCursor + Number(r.spessore)
        };
        depthCursor += Number(r.spessore);
        return layer;
      });


    // Infotab resizing
    const infotabRef = useRef(null);
    const [infotabWidth, setInfotabWidth] = useState(500);
    const [isResizing, setIsResizing] = useState(false);
    const startX = useRef(0);
    const startWidth = useRef(0);

    // riempie atumaticamente i dati in fuzione di quello che arriva
     const [formData, setFormData] = useState({});
            useEffect(() => {
          if (incomingData) {
            setFormData(incomingData);
          }
        }, [incomingData]);
    //preparo i dati
     const buildTableFromIncoming = (data) => {
          if (!data.prof) return [];

          return data.prof.map((h, i) => ({
            N: i + 1,
            H: h,
            qc: data.parQC?.[i] ?? null,
            fs: data.parfs?.[i] ?? null,
            u2: data.paru?.[i] ?? null // CPTU
          }));
        };


    useEffect(() => {
      if (!incomingData) return;

      const data = incomingData;
      //IDGEOM
      setidgeom(data.id || "");
      //team
      setSelectedTeam(data.team_id || "");
      // ANAGRAFICA
      setNomeProva(data.name || "");
      setCommittente(data.comm || "");
      setLocalita(data.loc || "");
      setIndirizzo(data.add || "");
      setop(data.op || "");
      setdittes(data.dittes || "");
      // PARAMETRI
      setSonda(data.snd || "");
      setTipologia(data.tp || "");
      setCarotiere(data.car || "");
      setRivestimento(data.riv || "");
      setProfMax(data.profMax || "");
      setFalda(data.falda || "");
      setqpc(data.qpc ?? 0);
      setqbf(data.qbf ?? "");
      setqpz(data.qpz ?? "");
      setnote(data.note || "");
      setCoordinate(
          Array.isArray(data.coords2)
            ? `${data.coords2[0]},${data.coords2[1]}`
            : ""
        );

      // TESTS
      setSptTests(data.tests?.spt || []);
      setPocketTests(data.tests?.pkt || []);
      setTorvaneTests(data.tests?.torvane || []);
      setCampioni(data.tests?.campioni || []);

      // FESSURAZIONI
      setFessurazioni(data.tests?.fessurazioni || []);

      // LAYERS
      const incomingLayers = Array.isArray(data.layers) ? data.layers : [];

      const baseLayers = Array.from({ length: 20 }, (_, i) => ({
        N: i + 1,
        spessore: "",
        colore: "",
        texture: "none",
        descrizione: "",
      }));

      incomingLayers.slice(0, 20).forEach((l, i) => {
        baseLayers[i] = {
          N: i + 1,
          spessore: l.spessore != null ? String(l.spessore) : "",
          colore: l.colore ?? "",
          texture: l.texture ?? "none",
          descrizione: l.descrizione ?? "",
        };
      });

      setAnalisiData(baseLayers);
    }, [incomingData]);



      const resetta = () => {
          navigate(location.pathname, { state: null });
          window.location.reload();
        };

    //funzione soft reset
    const resetAllForFileLoad = () => {
      // progetto e mappa
      setSelectedProject('');
      setCoordinate('');
      setIsMapClickActive(false);
      // dati prova
      setNomeProva('');
      setCommittente('');
      setLocalita('');
      setIndirizzo('');
      //idgeometria
      setidgeom(null)
      // team
      setSelectedTeam(null);
      // falda (🔴 AGGIUNTO)
      setFalda(0);
      }


    //salvataggio su database
    const buildLTdata = (tipoProva) => {

      const layers = (analisiData || [])
        .filter(row => Number(row.spessore ?? 0) > 0)
        .map(row => ({
          N: row.N,
          spessore: Number(row.spessore),
          colore: row.colore,
          texture: row.texture,
          descrizione: row.descrizione
        }));

      const anagrafica = {
          nomeProva: nomeProva,
          committente: committente,
          localita: localita,
          indirizzo: indirizzo,
          dittes: dittes,
          op: op
       };

      const parametri = {
        snd:sonda,
        tp:tipologia,
        car:carotiere,
        riv:rivestimento,
        profMax: Number(profMax || 0),
        falda: falda !== "" && falda !== null ? Number(falda) : "",
        qpc: Number(qpc || 0),
        qbf: qbf !== "" && qbf !== null ? Number(qbf) : "",
        qpz: qpz !== "" && qpz !== null ? Number(qpz) : "",
        note
      };

      // 🔥 RIMOZIONE ID DA TUTTI I TEST
      const cleanTestsArray = (arr) =>
        (arr || []).map(({ id, ...rest }) => rest);

      const tests = {
        spt: cleanTestsArray(sptTests),
        pkt: cleanTestsArray(pocketTests),
        torvane: cleanTestsArray(torvaneTests),
        campioni: cleanTestsArray(campioni),
        fessurazioni: cleanTestsArray(fessurazioni)
      };

      const payload = [{
        Tipo: tipoProva,
        anagrafica,
        parametri,
        layers,
        tests,
        geom: coordinate,
        team_id:selectedTeam
      }];

      //console.log("🚀 JSON PULITO SENZA ID:",JSON.stringify(payload, null, 2));
      return payload;
    };


   const toDB = async () => {
      try {

        // JSON completo stratigrafia
        const borehole_data = buildLTdata(tipoProva);

        let geomString;

        if (Array.isArray(coordinate)) {
          geomString = coordinate.join(',');
        } else if (typeof coordinate === 'string') {
          geomString = coordinate;
        } else {
          geomString = '';
        }

        const formData = {
          tipo_prova: tipoProva,

          // dati anagrafici
          committente: committente,
          luogo: localita,
          indirizzo: indirizzo,
          nome_prova: nomeProva,

          note: note,
          geom: geomString,

          // JSON COMPLETO
          input_data: [],
          output_data: borehole_data,
          param_data: [],
          stratigraphy_data: [],

          team_id: selectedTeam,
        };

        const config = {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        };

        let response;

        if (idgeom) {

          // UPDATE
          response = await axios.put(
            `https://hat.sofhare.com/save-geognostiche/${idgeom}/`,
            formData,
            config
          );

          toast("Aggiornamento completato con successo!", {
            type: "success",
          });

        } else {

          // CREATE
          response = await axios.post(
            `https://hat.sofhare.com/save-geognostiche/`,
            formData,
            config
          );

          setidgeom(response.data.id);

          toast("Archiviazione completata con successo!", {
            type: "success",
          });
        }

        console.log("SALVATO:", response.data);

      } catch (error) {
        console.error(
          "Errore completo:",
          error.response?.data || error
        );
      }
    };


    //resizing infotab
    const handleMouseDown = (event) => {
        setIsResizing(true);
        startX.current = event.clientX;
        startWidth.current = infotabRef.current.offsetWidth;

        const handleMouseMove = (e) => {
            const newWidth = Math.max(150, startWidth.current + (e.clientX - startX.current));
            setInfotabWidth(newWidth);
        };

        const handleMouseUp = () => {
            setIsResizing(false);
            document.removeEventListener('mousemove', handleMouseMove);
            document.removeEventListener('mouseup', handleMouseUp);
        };

        document.addEventListener('mousemove', handleMouseMove);
        document.addEventListener('mouseup', handleMouseUp);
    };

    // Render menu content
    const renderContent = () => {
        switch (selectedMenu) {
            case 'input':
                return (
                  <div className="container-software">
                    <div className="container-select">
                      <div className="field">
                          <label className="label">Sonda </label>
                          <input
                              type="text"
                              className="input-falda"
                              value={sonda}
                              placeholder="-"
                              onChange={(e) => setSonda(e.target.value)}
                          />
                        </div>
                        <div className="field">
                        <label className="label">Tipologia</label>
                        <select
                          className="layout-select"
                          value={tipologia}
                          onChange={(e) => setTipologia(e.target.value)}
                        >
                          <option value="">Seleziona</option>
                          <option value="Continuo">Continuo</option>
                          <option value="Distruzione">Distruzione</option>
                          <option value="Percussione">Percussione</option>
                        </select>
                      </div>
                    </div>

                    <div className="container-select">
                      <div className="field">
                          <label className="label">Carotiere</label>
                          <input
                            type="text"
                            className="input-falda"
                            value={carotiere}
                            placeholder="-"
                            onChange={(e) => setCarotiere(e.target.value)}
                          />
                        </div>

                        <div className="field">
                          <label className="label">Rivestimento</label>
                          <input
                            type="text"
                            className="input-falda"
                            value={rivestimento}
                            placeholder="-"
                            onChange={(e) => setRivestimento(e.target.value)}
                          />
                        </div>
                    </div>

                    {/* NUOVI CAMPI */}
                    <div className="container-select">
                      <div className="field">
                          <label className="label">Prof. max</label>
                          <input
                            type="number"
                            className="input-falda"
                            value={profMax}
                            onChange={(e) => setProfMax(e.target.value)}
                            placeholder="0"
                            min="0"
                            step="0.01"
                          />
                        </div>
                      <div className="field">
                          <label className="label">Falda m da p.c.</label>
                          <input
                            type="number"
                            className="input-falda"
                            value={falda}
                            onChange={(e) => setFalda(e.target.value)}
                            placeholder=""
                            min="0"
                            step="0.01"
                          />
                        </div>
                    </div>

                    {/* NUOVI CAMPI */}
                    <div className="container-select">
                      <div className="field">
                          <label className="label">Quota p.c.</label>
                          <input
                            type="number"
                            className="input-falda"
                            value={qpc}
                            onChange={(e) => setqpc(e.target.value)}
                            placeholder="0"
                            min="0"
                            step="0.01"
                          />
                        </div>
                      <div className="field">
                          <label className="label">Quota b.f.</label>
                          <input
                            type="number"
                            className="input-falda"
                            value={qbf}
                            onChange={(e) => setqbf(e.target.value)}
                            placeholder="0"
                            min="0"
                            step="0.01"
                          />
                        </div>
                    </div>
                    <div className="field">
                          <label className="label">Quota piezometro</label>
                          <input
                            type="number"
                            className="input-falda"
                            value={qpz}
                            onChange={(e) => setqpz(e.target.value)}
                            placeholder="0"
                            min="0"
                            step="0.01"
                          />
                    </div>

                  </div>
                );

            case 'anagrafica':
                return(
                  <div className="container-software">
                      <div className="container-select">
                        {/* NOME PROVA */}
                        <div className="field">
                          <label className="label">Nome prova</label>
                          <input
                            type="text"
                            className="input-text"
                            value={nomeProva}
                            onChange={(e) => setNomeProva(e.target.value)}
                          />
                        </div>

                        {/* COMMITTENTE */}
                        <div className="field">
                          <label className="label">Committente</label>
                          <input
                            type="text"
                            className="input-text"
                            value={committente}
                            onChange={(e) => setCommittente(e.target.value)}
                          />
                        </div>

                        {/* LOCALITÀ */}
                        <div className="field">
                          <label className="label">Località</label>
                          <input
                            type="text"
                            className="input-text"
                            value={localita}
                            onChange={(e) => setLocalita(e.target.value)}
                          />
                        </div>

                        {/* INDIRIZZO */}
                        <div className="field">
                          <label className="label">Indirizzo</label>
                          <input
                            type="text"
                            className="input-text"
                            value={indirizzo}
                            onChange={(e) => setIndirizzo(e.target.value)}
                          />
                        </div>

                        {/* Ditta es */}
                        <div className="field">
                          <label className="label">Ditta Esecutrice</label>
                          <input
                            type="text"
                            className="input-text"
                            value={dittes}
                            onChange={(e) => setdittes(e.target.value)}
                          />
                        </div>

                        {/* Operatore */}
                        <div className="field">
                          <label className="label">Operatore</label>
                          <input
                            type="text"
                            className="input-text"
                            value={op}
                            onChange={(e) => setop(e.target.value)}
                          />
                        </div>
                      </div>
                  </div>
               );

            case 'analisi':
                return (
                    <div className="container-software">
                     <label className="label">Esporta </label>
                     <div className="container-select">
                            <div className="toolbarsw">
                                <button className="btnsw" onClick={printReport}>
                                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="icon">
                                          <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z" />
                                      </svg>
                                      <span className="tooltip-text">Salva report</span>
                                </button>
                            </div>
                     </div>

                      <div className="table-containersw">
                       <label className="label">Elabora </label>
                        <table className="software-table">

                          <thead>
                            <tr>
                              <th>N</th>
                              <th>Spessore</th>
                              <th>Colore</th>
                              <th>Texture</th>
                              <th>Descrizione</th>
                              <th style={{ width: "50px", textAlign: "center" }}></th>
                            </tr>
                          </thead>

                          <tbody>
                            {analisiData.map((row, i) => (
                              <tr key={i}>

                                {/* N */}
                                <td>{row.N}</td>

                                {/* SPESSORE */}
                                <td>
                                  <input
                                    type="number"
                                    value={row.spessore}
                                    onChange={(e) => {
                                      const value = e.target.value;
                                      setAnalisiData(prev =>
                                        prev.map((r, idx) =>
                                          idx === i ? { ...r, spessore: value } : r
                                        )
                                      );
                                    }}
                                    style={{ width: "60px", textAlign: "center" }}
                                  />
                                </td>

                                {/* COLORE */}
                                <td>
                                  <div className="color-dropdown">

                                    {/* bottone selezionato */}
                                    <div
                                      className="color-selected"
                                      onClick={() => toggleColorMenu(i)}
                                    >
                                      <div
                                        className="color-preview"
                                        style={{ backgroundColor: row.colore || "transparent" }}
                                      />
                                    </div>

                                    {/* menu */}
                                    {openColorIndex === i && (
                                      <div className="color-menu">
                                        {colors.map((color, idx) => (
                                          <div
                                            key={idx}
                                            className="color-item"
                                            style={{ backgroundColor: color }}
                                            onClick={() => {
                                              setAnalisiData(prev =>
                                                prev.map((r, idx2) =>
                                                  idx2 === i ? { ...r, colore: color } : r
                                                )
                                              );
                                              setOpenColorIndex(null);
                                            }}
                                          />
                                        ))}
                                      </div>
                                    )}

                                  </div>
                                </td>

                                {/* TEXTURE */}
                                <td>
                                  <div className="texture-dropdown">

                                    {/* bottone selezionato */}
                                    <div
                                      className="texture-selected"
                                      onClick={() => toggleTextureMenu(i)}
                                    >
                                      <div
                                        className="texture-preview-small"
                                        style={{
                                          backgroundImage: getTexture(row.texture)
                                        }}
                                      />
                                    </div>

                                    {/* menu */}
                                    {openTextureIndex === i && (
                                      <div className="texture-menu">

                                        {textures.map((t, idx) => (
                                          <div
                                            key={idx}
                                            className="texture-item"
                                            onClick={() => {
                                              setAnalisiData(prev =>
                                                prev.map((r, idx2) =>
                                                  idx2 === i ? { ...r, texture: t } : r
                                                )
                                              );
                                              setOpenTextureIndex(null);
                                            }}
                                          >
                                            <div
                                              className="texture-preview"
                                              style={getTextureStyle(t)}
                                            />
                                          </div>
                                        ))}

                                      </div>
                                    )}

                                  </div>
                                </td>

                                <td
                                  style={{
                                    height: `${row.spessore}px`,
                                    alignItems: "center",   // centra verticalmente
                                    justifyContent: "center" // centra orizzontalmente
                                  }}
                                >
                                  <input
                                    type="text"
                                    value={row.descrizione}
                                    onChange={(e) => {
                                      const value = e.target.value;
                                      setAnalisiData(prev =>
                                        prev.map((r, idx) =>
                                          idx === i ? { ...r, descrizione: value } : r
                                        )
                                      );
                                    }}
                                    style={{
                                      width: "130px",
                                      textAlign: "center"
                                    }}
                                  />
                                </td>

                                <td style={{ textAlign: "center" }}>
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    strokeWidth={1.5}
                                    stroke="currentColor"
                                    className="icon"
                                    style={{ cursor: "pointer" }}
                                    onClick={() => deleteRow(i)}
                                  >
                                    <path
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      d="M12 9.75 14.25 12m0 0 2.25 2.25M14.25 12l2.25-2.25M14.25 12 12 14.25m-2.58 4.92-6.374-6.375a1.125 1.125 0 0 1 0-1.59L9.42 4.83c.21-.211.497-.33.795-.33H19.5a2.25 2.25 0 0 1 2.25 2.25v10.5a2.25 2.25 0 0 1-2.25 2.25h-9.284c-.298 0-.585-.119-.795-.33Z"
                                    />
                                  </svg>
                                </td>


                              </tr>
                            ))}
                          </tbody>

                        </table>
                        <div
                          onClick={handleAddRow}
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            marginTop: "10px",
                            cursor: "pointer"
                          }}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth={1.5}
                            stroke="currentColor"
                            style={{ width: 28, height: 28 }}
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              d="M12 9v6m3-3H9m12 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                            />
                          </svg>
                        </div>
                      </div>
                    </div>
                  );
            case 'info':
                return (
                <div className="container-software">
                  <div className="table-containersw">
                    <label className="label">Fessure Piezometro</label>
                    {/* BOTTONA + */}
                    <div
                      onClick={addFessurazione}
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        cursor: "pointer",
                        marginBottom: "10px"
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth={1.5}
                        stroke="currentColor"
                        style={{ width: 28, height: 28 }}
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M12 9v6m3-3H9m12 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                        />
                      </svg>
                    </div>

                    {/* LISTA */}
                    <div>
                      {fessurazioni.map((item, i) => (
                        <div
                          key={item.id}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                            padding: "8px 10px",
                            marginBottom: "6px",
                            background: "#f5f5f5",
                            borderRadius: "6px"
                          }}
                        >

                          {/* N */}
                          <div style={{ width: "30px" }}>{i + 1}</div>

                          {/* INIZIO */}
                          <input
                            type="number"
                            placeholder="Inizio"
                            value={item.inizio}
                            onChange={(e) => {
                              const value = e.target.value;
                              setFessurazioni(prev =>
                                prev.map(f =>
                                  f.id === item.id ? { ...f, inizio: value } : f
                                )
                              );
                            }}
                            style={{ width: "80px", textAlign: "center" }}
                          />

                          {/* FINE */}
                          <input
                            type="number"
                            placeholder="Fine"
                            value={item.fine}
                            onChange={(e) => {
                              const value = e.target.value;
                              setFessurazioni(prev =>
                                prev.map(f =>
                                  f.id === item.id ? { ...f, fine: value } : f
                                )
                              );
                            }}
                            style={{ width: "80px", textAlign: "center" }}
                          />

                          {/* DELETE */}
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth={1.5}
                            stroke="currentColor"
                            style={{ width: 18, height: 18, cursor: "pointer" }}
                            onClick={() => removeFessurazione(item.id)}
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                               d="M12 9.75 14.25 12m0 0 2.25 2.25M14.25 12l2.25-2.25M14.25 12 12 14.25m-2.58 4.92-6.374-6.375a1.125 1.125 0 0 1 0-1.59L9.42 4.83c.21-.211.497-.33.795-.33H19.5a2.25 2.25 0 0 1 2.25 2.25v10.5a2.25 2.25 0 0 1-2.25 2.25h-9.284c-.298 0-.585-.119-.795-.33Z"
                            />
                          </svg>

                        </div>
                      ))}
                    </div>
                  </div>

                  <div className="table-containersw">
                      <label className="label">Pocket Test</label>
                      {/* BOTTONE + */}
                      <div
                        onClick={addPocketTest}
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          cursor: "pointer",
                          marginBottom: "10px"
                        }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          strokeWidth={1.5}
                          stroke="currentColor"
                          style={{ width: 28, height: 28 }}
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M12 9v6m3-3H9m12 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                          />
                        </svg>
                      </div>

                      {/* LISTA */}
                      <div>
                        {pocketTests.map((item, i) => (
                          <div
                            key={item.id}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "10px",
                              padding: "8px 10px",
                              marginBottom: "6px",
                              background: "#f5f5f5",
                              borderRadius: "6px"
                            }}
                          >
                            {/* N */}
                            <div style={{ width: "30px" }}>{i + 1}</div>

                            {/* VALORE */}
                            <input
                              type="number"
                              placeholder="Valore"
                              value={item.valore}
                              onChange={(e) => {
                                const value = e.target.value;
                                setPocketTests(prev =>
                                  prev.map(p =>
                                    p.id === item.id ? { ...p, valore: value } : p
                                  )
                                );
                              }}
                              style={{ width: "80px", textAlign: "center" }}
                            />

                            {/* PROFONDITÀ */}
                            <input
                              type="number"
                              placeholder="Profondità"
                              value={item.profondita}
                              onChange={(e) => {
                                const value = e.target.value;
                                setPocketTests(prev =>
                                  prev.map(p =>
                                    p.id === item.id ? { ...p, profondita: value } : p
                                  )
                                );
                              }}
                              style={{ width: "100px", textAlign: "center" }}
                            />

                            {/* DELETE */}
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 24 24"
                              strokeWidth={1.5}
                              stroke="currentColor"
                              style={{ width: 18, height: 18, cursor: "pointer" }}
                              onClick={() => removePocketTest(item.id)}
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M12 9.75 14.25 12m0 0 2.25 2.25M14.25 12l2.25-2.25M14.25 12 12 14.25"
                              />
                            </svg>
                          </div>
                        ))}
                      </div>
                    </div>

                    <div className="table-containersw">
                      <label className="label">Torvane Test</label>
                      {/* BOTTONE + */}
                      <div
                        onClick={addTorvaneTest}
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          cursor: "pointer",
                          marginBottom: "10px"
                        }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          strokeWidth={1.5}
                          stroke="currentColor"
                          style={{ width: 28, height: 28 }}
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M12 9v6m3-3H9m12 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                          />
                        </svg>
                      </div>

                      {/* LISTA */}
                      <div>
                        {torvaneTests.map((item, i) => (
                          <div
                            key={item.id}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "10px",
                              padding: "8px 10px",
                              marginBottom: "6px",
                              background: "#f5f5f5",
                              borderRadius: "6px"
                            }}
                          >
                            {/* N */}
                            <div style={{ width: "30px" }}>{i + 1}</div>

                            {/* VALORE */}
                            <input
                              type="number"
                              placeholder="Valore"
                              value={item.valore}
                              onChange={(e) => {
                                const value = e.target.value;
                                setTorvaneTests(prev =>
                                  prev.map(t =>
                                    t.id === item.id ? { ...t, valore: value } : t
                                  )
                                );
                              }}
                              style={{ width: "80px", textAlign: "center" }}
                            />

                            {/* PROFONDITÀ */}
                            <input
                              type="number"
                              placeholder="Profondità"
                              value={item.profondita}
                              onChange={(e) => {
                                const value = e.target.value;
                                setTorvaneTests(prev =>
                                  prev.map(t =>
                                    t.id === item.id ? { ...t, profondita: value } : t
                                  )
                                );
                              }}
                              style={{ width: "100px", textAlign: "center" }}
                            />

                            {/* DELETE */}
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 24 24"
                              strokeWidth={1.5}
                              stroke="currentColor"
                              style={{ width: 18, height: 18, cursor: "pointer" }}
                              onClick={() => removeTorvaneTest(item.id)}
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M12 9.75 14.25 12m0 0 2.25 2.25M14.25 12l2.25-2.25M14.25 12 12 14.25"
                              />
                            </svg>
                          </div>
                        ))}
                      </div>
                    </div>

                    <div className="table-containersw">
                      <label className="label">SPT</label>
                      {/* BOTTONE + */}
                      <div
                        onClick={addSptTest}
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          cursor: "pointer",
                          marginBottom: "10px"
                        }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          strokeWidth={1.5}
                          stroke="currentColor"
                          style={{ width: 28, height: 28 }}
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M12 9v6m3-3H9m12 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                          />
                        </svg>
                      </div>

                      {/* LISTA */}
                      <div>
                        {sptTests.map((item, i) => (
                          <div
                            key={item.id}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "10px",
                              padding: "8px 10px",
                              marginBottom: "6px",
                              background: "#f5f5f5",
                              borderRadius: "6px"
                            }}
                          >
                            {/* N */}
                            <div style={{ width: "30px" }}>{i + 1}</div>

                            {/* VALORE */}
                            <input
                              type="number"
                              placeholder="Valore"
                              value={item.valore}
                              onChange={(e) => {
                                const value = e.target.value;
                                setSptTests(prev =>
                                  prev.map(s =>
                                    s.id === item.id ? { ...s, valore: value } : s
                                  )
                                );
                              }}
                              style={{ width: "80px", textAlign: "center" }}
                            />

                            {/* PROFONDITÀ */}
                            <input
                              type="number"
                              placeholder="Profondità"
                              value={item.profondita}
                              onChange={(e) => {
                                const value = e.target.value;
                                setSptTests(prev =>
                                  prev.map(s =>
                                    s.id === item.id ? { ...s, profondita: value } : s
                                  )
                                );
                              }}
                              style={{ width: "100px", textAlign: "center" }}
                            />

                            {/* DELETE */}
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 24 24"
                              strokeWidth={1.5}
                              stroke="currentColor"
                              style={{ width: 18, height: 18, cursor: "pointer" }}
                              onClick={() => removeSptTest(item.id)}
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M12 9.75 14.25 12m0 0 2.25 2.25M14.25 12l2.25-2.25M14.25 12 12 14.25"
                              />
                            </svg>
                          </div>
                        ))}
                      </div>
                    </div>

                    <div className="table-containersw">
                      <label className="label">Campioni</label>

                      {/* BOTTONE + */}
                      <div
                        onClick={addCampione}
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          cursor: "pointer",
                          marginBottom: "10px"
                        }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          strokeWidth={1.5}
                          stroke="currentColor"
                          style={{ width: 28, height: 28 }}
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M12 9v6m3-3H9m12 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                          />
                        </svg>
                      </div>

                      {/* LISTA */}
                      <div>
                        {campioni.map((item, i) => (
                          <div
                            key={item.id}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                              padding: "8px 10px",
                              marginBottom: "6px",
                              background: "#f5f5f5",
                              borderRadius: "6px"
                            }}
                          >
                            {/* N */}
                            <div style={{ width: "25px" }}>{i + 1}</div>

                            {/* TIPOLOGIA */}
                            <select
                              value={item.tipologia}
                              onChange={(e) => {
                                const value = e.target.value;
                                setCampioni(prev =>
                                  prev.map(c =>
                                    c.id === item.id ? { ...c, tipologia: value } : c
                                  )
                                );
                              }}
                              style={{ width: "90px" }}
                            >
                              <option value="">Tipo</option>
                              <option value="CD/R">CD/R</option>
                              <option value="CDL">CDL</option>
                              <option value="CI">CI</option>
                            </select>

                            {/* QUALITÀ */}
                            <select
                              value={item.qualita}
                              onChange={(e) => {
                                const value = e.target.value;
                                setCampioni(prev =>
                                  prev.map(c =>
                                    c.id === item.id ? { ...c, qualita: value } : c
                                  )
                                );
                              }}
                              style={{ width: "70px" }}
                            >
                              <option value="Q1">Q1</option>
                              <option value="Q2">Q2</option>
                              <option value="Q3">Q3</option>
                              <option value="Q4">Q4</option>
                              <option value="Q5">Q5</option>
                            </select>

                            {/* PROFONDITÀ */}
                            <input
                              type="number"
                              placeholder="Prof."
                              value={item.profondita}
                              onChange={(e) => {
                                const value = e.target.value;
                                setCampioni(prev =>
                                  prev.map(c =>
                                    c.id === item.id ? { ...c, profondita: value } : c
                                  )
                                );
                              }}
                              style={{ width: "70px", textAlign: "center" }}
                            />

                            {/* 👇 NUOVO: CAMPIONATORE */}
                            <select
                              value={item.campionatore}
                              onChange={(e) => {
                                const value = e.target.value;
                                setCampioni(prev =>
                                  prev.map(c =>
                                    c.id === item.id ? { ...c, campionatore: value } : c
                                  )
                                );
                              }}
                              style={{ width: "130px" }}
                            >
                              <option value="">Campionatore</option>
                              <option value="Shelby">Shelby</option>
                              <option value="Denison">Denison</option>
                              <option value="Mazier">Mazier</option>
                            </select>

                            {/* DELETE */}
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 24 24"
                              strokeWidth={1.5}
                              stroke="currentColor"
                              style={{ width: 18, height: 18, cursor: "pointer" }}
                              onClick={() => removeCampione(item.id)}
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M12 9.75 14.25 12m0 0 2.25 2.25M14.25 12l2.25-2.25M14.25 12 12 14.25"
                              />
                            </svg>
                          </div>
                        ))}
                      </div>
                    </div>

                </div>
                );
            case 'archivia':
                return (

                <div className="container-software">
                    <label className="label">Database </label>
                     <div className="container-select">
                            <div className="toolbarsw">
                                <button className="btnsw" onClick={() => toDB()}>
                                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="icon">
                                          <path strokeLinecap="round" strokeLinejoin="round" d="M20.25 6.375c0 2.278-3.694 4.125-8.25 4.125S3.75 8.653 3.75 6.375m16.5 0c0-2.278-3.694-4.125-8.25-4.125S3.75 4.097 3.75 6.375m16.5 0v11.25c0 2.278-3.694 4.125-8.25 4.125s-8.25-1.847-8.25-4.125V6.375m16.5 0v3.75m-16.5-3.75v3.75m16.5 0v3.75C20.25 16.153 16.556 18 12 18s-8.25-1.847-8.25-4.125v-3.75m16.5 0c0 2.278-3.694 4.125-8.25 4.125s-8.25-1.847-8.25-4.125" />
                                      </svg>
                                      <span className="tooltip-text">Archivia</span>
                                </button>
                                <button className="btnsw" onClick={() => navigate('/sHapp')}>
                                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="icon">
                                          <path strokeLinecap="round" strokeLinejoin="round" d="m20.893 13.393-1.135-1.135a2.252 2.252 0 0 1-.421-.585l-1.08-2.16a.414.414 0 0 0-.663-.107.827.827 0 0 1-.812.21l-1.273-.363a.89.89 0 0 0-.738 1.595l.587.39c.59.395.674 1.23.172 1.732l-.2.2c-.212.212-.33.498-.33.796v.41c0 .409-.11.809-.32 1.158l-1.315 2.191a2.11 2.11 0 0 1-1.81 1.025 1.055 1.055 0 0 1-1.055-1.055v-1.172c0-.92-.56-1.747-1.414-2.089l-.655-.261a2.25 2.25 0 0 1-1.383-2.46l.007-.042a2.25 2.25 0 0 1 .29-.787l.09-.15a2.25 2.25 0 0 1 2.37-1.048l1.178.236a1.125 1.125 0 0 0 1.302-.795l.208-.73a1.125 1.125 0 0 0-.578-1.315l-.665-.332-.091.091a2.25 2.25 0 0 1-1.591.659h-.18c-.249 0-.487.1-.662.274a.931.931 0 0 1-1.458-1.137l1.411-2.353a2.25 2.25 0 0 0 .286-.76m11.928 9.869A9 9 0 0 0 8.965 3.525m11.928 9.868A9 9 0 1 1 8.965 3.525" />
                                        </svg>
                                      <span className="tooltip-text">Vai al Geodatabase</span>
                                </button>
                            </div>
                     </div>
                     <div className="container-software">

                             <label className="label">Id </label>
                             <div className="container-select">
                                  <div className="field">
                                    <input
                                      type="text"
                                      className="input-text"
                                      value={idgeom || ""}    // <-- prende lo stato
                                      readOnly
                                      placeholder="-"
                                    />
                             </div>
                             </div>

                             <label className="label">Note </label>
                             <div className="container-select">
                                  <div className="field">
                                    <input
                                      type="text"
                                      className="input-text"
                                      value={note || ""}   // <-- prende lo stato
                                      onChange={(e) => setnote(e.target.value)}
                                      placeholder="-"
                                    />
                             </div>
                             </div>

                             <label className="label">Seleziona Team </label>
                             <div className="container-select"style={{  heigth: "600px", overflow: "visible" }}>
                             <div className="field">
                                   <select className="layout-select" value={selectedTeam} onChange={e => setSelectedTeam(e.target.value)}>
                                      <option value="">Nessuno</option>
                                      {teams.map(t => <option key={t.id} value={t.id}>{t.name}</option>)}
                                    </select>
                             </div>
                             </div>

                             <label className="label">Coordinate </label>
                             <div className="container-select">
                                  <div className="field">
                                    <input
                                      type="text"
                                      className="input-text"
                                      value={coordinate || ""}   // <-- prende lo stato
                                      readOnly
                                      placeholder="-"
                                    />
                             </div>
                             </div>

                             <label className="label">Seleziona </label>
                             <div className="container-select"style={{  heigth: "600px", overflow: "visible" }}>
                             <div className="toolbarsw">
                                <div className="field">
                                    <select value={selectedProject} onChange={handleProjectChange} className="layout-select">
                                        <option value="">Select a Project</option>
                                        {projects.map((p, i) => (
                                          <option key={i} value={p}>{p}</option>
                                        ))}
                                   </select>
                                </div>
                                <button onClick={() => setIsMapClickActive(prev => !prev)} className="btnsw">
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="icon">
                                          <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v6m3-3H9m12 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                                        </svg>
                                    <span className="tooltip-text">Aggiungi manualmente</span>
                                </button>
                            </div>
                            </div>

                    </div>
                    <MapComponent_sw ref={mapRef}  onSendCoordinate={handleReceiveCoordinate} mapClickActive={isMapClickActive}/>
                   </div>
               );
            default:
                return null;
        }
    };


    return (
            <div className="Principal">
                <div className="layoutapp">
                    <div className="infotab" ref={infotabRef} style={{ width: `${infotabWidth}px` }}>
                        <div className="Title-sh">Borehole</div>
                        <hr className="divider" />
                        <div className="menu">
                            <ul>
                                <li
                                    onClick={() => setSelectedMenu('anagrafica')}
                                    className={selectedMenu === 'anagrafica' ? 'active' : ''}
                                >
                                    Anagrafica
                                </li>
                                <li
                                    onClick={() => setSelectedMenu('input')}
                                    className={selectedMenu === 'input' ? 'active' : ''}
                                >
                                    Input
                                </li>
                                <li
                                    onClick={() => setSelectedMenu('analisi')}
                                    className={selectedMenu === 'analisi' ? 'active' : ''}
                                >
                                    Elabora
                                </li>
                                <li
                                    onClick={() => setSelectedMenu('info')}
                                    className={selectedMenu === 'info' ? 'active' : ''}
                                >
                                    Dati
                                </li>
                                <li
                                    onClick={() => setSelectedMenu('archivia')}
                                    className={selectedMenu === 'archivia' ? 'active' : ''}
                                >
                                    Archivia
                                </li>
                            </ul>
                        </div>
                        {renderContent()}

                    </div>
                    <div className="App">
                        <div className="cpt-layout">
                          <div className="sondaggio-main">
                            <div className="cpt-single">
                              <div className="section-content-sond">
                              {/* REPORT GEOLOGICO */}
                                {activePanel === "report" && (
                                  <div className="geotech-sheet" id="reportFrame">
                                      <div className="delimiterborehole">
                                        <span>V.E.S. - Virtual Earth Suite</span>
                                        <span>Sviluppato dal Dott. Geol. Umberto Grechi</span>
                                      </div>
                                    {/* HEADER */}
                                    <div className="geotech-header">
                                      {/* SINISTRA */}
                                      <div className="header-left">
                                        <div>Ditta Esecutrice:<br /> {dittes || "-"}</div>
                                      </div>
                                      {/* CENTRO */}
                                      <div className="header-center">
                                        <div>Località: {localita || "-"}</div>
                                        <div>Indirizzo: {indirizzo || "-"}</div>
                                        <div>Committente: {committente || "-"}</div>
                                        <div>Data: {new Date().toLocaleDateString("it-IT")}</div>
                                      </div>
                                      {/* DESTRA */}
                                      <div className="header-center">
                                        <div>Sonda: {sonda || "-"}</div>
                                        <div>Carotiere: {carotiere || "-"}</div>
                                        <div>Rivestimento: {rivestimento || "-"}</div>
                                        <div>Operatore: {op || "-"}</div>
                                      </div>

                                    </div>
                                    <div className="geotech-header">
                                      <div className="header-left">
                                        <div>ID Sondaggio: {nomeProva || "-"}</div>
                                        <div>Prof. max: {profMax ? `${profMax} m` : "-"}</div>
                                        <div>Tipologia: {tipologia || "-"}</div>
                                      </div>
                                      <div className="header-center">
                                        <div>Prof. Falda: {falda ? `${falda} m` : "-"}</div>
                                        <div>Quota p.c.: {qpc ? `${qpc} m` : 0}</div>
                                        <div>B.f. Piezometro: {qbf ? `${qbf} m` : "-"}</div>
                                      </div>

                                      <div className="header-right">
                                          <div>WGS84 (EPGS:4326)</div>

                                          <div>
                                            Lat: {parseFloat(coordinate.split(",")[0]).toFixed(3)}
                                          </div>

                                          <div>
                                            Lon: {parseFloat(coordinate.split(",")[1]).toFixed(3)}
                                          </div>
                                     </div>
                                    </div>
                                    {/* HEADER COLONNE */}
                                    <div className="geotech-columns-header">
                                      <div className="col">H m</div>
                                      <div className="col">Sp</div>
                                      <div className="col">Stratigrafia</div>
                                      <div className="col">Descrizione</div>
                                      <div className="col">Falda</div>
                                      <div className="col">Pz</div>
                                      <div className="col">Pt kg/cm2</div>
                                      <div className="col">Tv kg/cm2</div>
                                      <div className="col">SPT</div>
                                      <div className="col">C</div>
                                    </div>
                                    {/* BODY */}
                                    <div className="geotech-body">
                                      <div className="col profondita">
                                        <div className="depth-scale">
                                          {Array.from({ length: profMax}).map((_, i) => (
                                            <div
                                              key={i}
                                              className={`depth-row ${i % 2 === 0 ? "white" : "black"}`}
                                            >
                                              {/* NON mostrare lo 0 */}
                                              <span className="depth-label">
                                                {i === 0 ? "" : i}
                                              </span>
                                            </div>
                                          ))}
                                        </div>
                                      </div>

                                    {/* ✅ NUOVA COLONNA */}
                                    <div className="col spessore" style={{ position: "relative" }}>
                                        {analisiData
                                            .filter(r => r.spessore > 0)
                                            .reduce((acc, row, i) => {
                                                const prevHeight = acc.totalHeight;
                                                const blockHeight = Number(row.spessore) * 40;

                                                acc.items.push(
                                                    <div
                                                        key={i}
                                                        style={{
                                                            position: "absolute",
                                                            top: `${prevHeight}px`,
                                                            height: `${blockHeight}px`,
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            width: "100%",
                                                            fontSize: "11px",
                                                            fontFamily: "Roboto",
                                                            fontWeight: "bold",

                                                            borderBottom: "1px solid #000", // 👈 bordo
                                                            boxSizing: "border-box"
                                                        }}
                                                    >
                                                        {row.spessore}
                                                    </div>
                                                );

                                                acc.totalHeight += blockHeight;
                                                return acc;
                                            }, { items: [], totalHeight: 0 }).items}
                                    </div>


                                     <div className="col stratigrafia">
                                      {analisiData
                                        .filter(r => r.spessore > 0)
                                        .map((row, i) => (
                                          <div
                                            key={i}
                                            className="layer"
                                            style={{
                                              backgroundColor: row.colore || "#fff",
                                              backgroundImage: getTexture(row.texture),
                                              backgroundSize: getTextureSize(row.texture),
                                              backgroundRepeat: "repeat",
                                              // 🔥 SOLO ALTEZZA, NIENTE POSITION
                                              height: `${Number(row.spessore) * 40}px`
                                            }}
                                          >
                                          </div>
                                        ))
                                      }
                                    </div>


                                     <div className="col descrizione" style={{ position: "relative" }}>
                                          {analisiData
                                            .filter(r => r.spessore > 0)
                                            .reduce((acc, row, i) => {
                                              const prevHeight = acc.totalHeight;
                                              acc.items.push(
                                                <div
                                                  key={i}
                                                  style={{
                                                    position: "absolute",
                                                    top: `${prevHeight}px`,
                                                    height: `${Number(row.spessore) * 40}px`,
                                                    display: "flex",
                                                    alignItems: "center",
                                                    padding: "4px",
                                                    fontSize: "11px",
                                                    fontFamily: "Roboto",
                                                    fontWeight: "bold",
                                                    width: "100%"
                                                  }}
                                                >
                                                  {row.descrizione}
                                                </div>
                                              );
                                              acc.totalHeight += Number(row.spessore) * 40;
                                              return acc;
                                            }, { items: [], totalHeight: 0 }).items}
                                     </div>

                                    <div className="col falda" style={{ position: "relative" }}>
                                      {falda && (
                                        <>
                                          {/* LINEA FALDA PRINCIPALE */}
                                          <div
                                            style={{
                                              position: "absolute",
                                              top: `${faldaPx}px`,
                                              left: "50%",
                                              transform: "translateX(-50%)",
                                              width: "80%",
                                              height: "2px",
                                              backgroundColor: "#4f92e8",
                                            }}
                                          />

                                          {/* SECONDA LINEA (6px sotto) */}
                                          <div
                                            style={{
                                              position: "absolute",
                                              top: `${faldaPx + 6}px`,
                                              left: "50%",
                                              transform: "translateX(-50%)",
                                              width: "60%",
                                              height: "2px",
                                              backgroundColor: "#4f92e8",
                                              opacity: 0.6, // opzionale per differenziarla
                                            }}
                                          />

                                          {/* TRIANGOLO SOPRA */}
                                          <div
                                            style={{
                                              position: "absolute",
                                              top: `${faldaPx - 18}px`,
                                              left: "50%",
                                              transform: "translateX(-50%)",
                                            }}
                                          >
                                            {/* TRIANGOLO NERO */}
                                            <div
                                              style={{
                                                width: 0,
                                                height: 0,
                                                borderLeft: "10px solid transparent",
                                                borderRight: "10px solid transparent",
                                                borderTop: "16px solid black",
                                              }}
                                            />

                                            {/* TRIANGOLO BLU */}
                                            <div
                                              style={{
                                                position: "absolute",
                                                top: "2px",
                                                left: "2px",
                                                width: 0,
                                                height: 0,
                                                borderLeft: "8px solid transparent",
                                                borderRight: "8px solid transparent",
                                                borderTop: "14px solid #4f92e8",
                                              }}
                                            />
                                          </div>
                                        </>
                                      )}
                                    </div>

                                    <div className="col pz" style={{ position: "relative" }}>
                                      {/* =========================
                                          LINEE VERTICALI PZ
                                      ========================= */}
                                      {qpz !== null && qpz !== undefined && qpz !== "" && (
                                        <>
                                          <div
                                            style={{
                                              position: "absolute",
                                              left: "30%",
                                              top: `${qpz * 40}px`,
                                              width: "2px",
                                              height: `${(profMax - qpz) * 40}px`,
                                              backgroundColor: "#0f172a",
                                              opacity: 0.6,
                                              pointerEvents: "none",
                                              zIndex: 2
                                            }}
                                          />

                                          <div
                                            style={{
                                              position: "absolute",
                                              left: "70%",
                                              top: `${qpz * 40}px`,
                                              width: "2px",
                                              height: `${(profMax - qpz) * 40}px`,
                                              backgroundColor: "#0f172a",
                                              opacity: 0.6,
                                              pointerEvents: "none",
                                              zIndex: 2
                                            }}
                                          />
                                        </>
                                      )}

                                      {/* =========================
                                          FESSURAZIONI (RETINI ORIZZONTALI)
                                      ========================= */}
                                      {fessurazioni.map((f, i) => {
                                        if (!f.inizio || !f.fine) return null;

                                        const top = Number(f.inizio) * 40;
                                        const height = (Number(f.fine) - Number(f.inizio)) * 40;

                                        return (
                                          <div key={i} style={{ position: "absolute", width: "100%" }}>

                                            {/* fascia principale */}
                                            <div
                                              style={{
                                                position: "absolute",
                                                left: "0%",
                                                top: `${top}px`,
                                                width: "100%",
                                                height: `${height}px`,
                                                backgroundColor: "#4f92e8",
                                                opacity: 0.2,
                                                pointerEvents: "none",
                                                zIndex: 1
                                              }}
                                            />

                                            {/* retino orizzontale interno */}
                                            {Array.from({ length: Math.floor(height / 10) }).map((_, idx) => (
                                              <div
                                                key={idx}
                                                style={{
                                                  position: "absolute",
                                                  left: "30%",
                                                  top: `${top + idx * 10}px`,
                                                  width: "40%",
                                                  height: "1px",
                                                  backgroundColor: "#4f92e8",
                                                  opacity: 0.5,
                                                  pointerEvents: "none",
                                                  zIndex: 1
                                                }}
                                              />
                                            ))}

                                          </div>
                                        );
                                      })}
                                    </div>

                                    <div className="col pkt" style={{ position: "relative" }}>
                                      {pocketTests.map((p) => {
                                        if (!p.profondita || !p.valore) return null;

                                        const top = Number(p.profondita) * 40;

                                        return (
                                          <div key={p.id} style={{ position: "absolute", width: "100%" }}>

                                            {/* LINEA ORIZZONTALE */}
                                            <div
                                              style={{
                                                position: "absolute",
                                                left: "10%",
                                                top: `${top}px`,
                                                width: "25%",
                                                height: "2px",
                                                backgroundColor: "#000",
                                                zIndex: 2
                                              }}
                                            />

                                            {/* VALORE A DESTRA */}
                                            <div
                                              style={{
                                                position: "absolute",
                                                left: "50%",
                                                top: `${top}px`,
                                                transform: "translateY(-50%)",
                                                fontSize: "11px",
                                                color: "#000",
                                                fontWeight: "500",
                                                whiteSpace: "nowrap"
                                              }}
                                            >
                                              {p.valore}
                                            </div>

                                          </div>
                                        );
                                      })}
                                    </div>

                                    <div className="col torvane" style={{ position: "relative" }}>
                                      {torvaneTests.map((t) => {
                                        if (!t.profondita || !t.valore) return null;

                                        const top = Number(t.profondita) * 40;

                                        return (
                                          <div key={t.id} style={{ position: "absolute", width: "100%" }}>

                                            {/* LINEA ORIZZONTALE */}
                                            <div
                                              style={{
                                                position: "absolute",
                                                left: "10%",
                                                top: `${top}px`,
                                                width: "25%",
                                                height: "2px",
                                                backgroundColor: "#000",
                                                zIndex: 2
                                              }}
                                            />

                                            {/* VALORE A DESTRA */}
                                            <div
                                              style={{
                                                position: "absolute",
                                                left: "50%",
                                                top: `${top}px`,
                                                transform: "translateY(-50%)",
                                                fontSize: "11px",
                                                color: "#000",
                                                fontWeight: "500",
                                                whiteSpace: "nowrap"
                                              }}
                                            >
                                              {t.valore}
                                            </div>

                                          </div>
                                        );
                                      })}
                                    </div>
                                    <div className="col spt" style={{ position: "relative" }}>
                                      {sptTests.map((s) => {
                                        if (!s.profondita || !s.valore) return null;

                                        const top = Number(s.profondita) * 40;

                                        return (
                                          <div key={s.id} style={{ position: "absolute", width: "100%" }}>

                                            {/* LINEA ORIZZONTALE */}
                                            <div
                                              style={{
                                                position: "absolute",
                                                left: "10%",
                                                top: `${top}px`,
                                                width: "25%",
                                                height: "2px",
                                                backgroundColor: "#000",
                                                zIndex: 2
                                              }}
                                            />

                                            {/* VALORE */}
                                            <div
                                              style={{
                                                position: "absolute",
                                                left: "50%",
                                                top: `${top}px`,
                                                transform: "translateY(-50%)",
                                                fontSize: "11px",
                                                color: "#000",
                                                fontWeight: "500",
                                                whiteSpace: "nowrap"
                                              }}
                                            >
                                              {s.valore}
                                            </div>

                                          </div>
                                        );
                                      })}
                                    </div>

                                    <div className="col campioni" style={{ position: "relative" }}>
                                      {campioni.map((c) => {
                                        if (!c.profondita || !c.tipologia || !c.qualita) return null;

                                        const top = Number(c.profondita) * 40;

                                        // 🔥 conversione campionatore
                                        let campSigla = "";
                                        switch (c.campionatore) {
                                          case "Shelby":
                                            campSigla = "S";
                                            break;
                                          case "Denison":
                                            campSigla = "D";
                                            break;
                                          case "Mazier":
                                            campSigla = "M";
                                            break;
                                          default:
                                            campSigla = "";
                                        }

                                        return (
                                          <div key={c.id} style={{ position: "absolute", width: "100%" }}>

                                            {/* LINEA */}
                                            <div
                                              style={{
                                                position: "absolute",
                                                left: "2%",
                                                top: `${top}px`,
                                                width: "7%",
                                                height: "2px",
                                                backgroundColor: "#000"
                                              }}
                                            />

                                            {/* CAMPIONATORE (S / D / M) SOPRA */}
                                            {campSigla && (
                                              <div
                                                style={{
                                                  position: "absolute",
                                                  left: "15%",
                                                  top: `${top - 10}px`,
                                                  transform: "translateY(-50%)",
                                                  fontSize: "9px",
                                                  fontWeight: "700",
                                                  color: "#111",
                                                  whiteSpace: "nowrap"
                                                }}
                                              >
                                                {campSigla}
                                              </div>
                                            )}

                                            {/* TIPOLOGIA - QUALITÀ */}
                                            <div
                                              style={{
                                                position: "absolute",
                                                left: "15%",
                                                top: `${top + 6}px`,
                                                transform: "translateY(-50%)",
                                                fontSize: "10px",
                                                fontWeight: "500",
                                                whiteSpace: "nowrap"
                                              }}
                                            >
                                              {c.tipologia}-{c.qualita}
                                            </div>

                                          </div>
                                        );
                                      })}
                                    </div>
                                    </div>

                                     <div
                                          style={{
                                            marginTop: "20px",
                                            padding: "10px",
                                            borderRadius: "6px",
                                            fontSize: "12px"
                                          }}
                                        >
                                          <div style={{ fontWeight: "600", marginBottom: "8px" }}>
                                            Legenda Campioni
                                          </div>

                                          <div style={{ display: "flex", gap: "20px", flexWrap: "wrap", marginBottom: "8px" }}>
                                            <div><b>CD/R</b> = Campione disturbato o rimaneggiato</div>
                                            <div><b>CDL</b> = Campione a disturbo limitato</div>
                                            <div><b>CI</b> = Campione indisturbato</div>
                                          </div>

                                          <div style={{ display: "flex", gap: "15px", flexWrap: "wrap", marginBottom: "8px" }}>
                                            <div><b>Q1</b> = qualità molto bassa</div>
                                            <div><b>Q2</b> = qualità bassa</div>
                                            <div><b>Q3</b> = qualità media</div>
                                            <div><b>Q4</b> = qualità alta</div>
                                            <div><b>Q5</b> = qualità molto alta</div>
                                          </div>

                                          <div style={{ display: "flex", gap: "20px", flexWrap: "wrap" }}>
                                            <div><b>S</b> = Shelby</div>
                                            <div><b>D</b> = Denison</div>
                                            <div><b>M</b> = Mazier</div>
                                          </div>
                                        </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                            className="resize-handle"
                            onMouseDown={handleMouseDown}
                        />
                    </div>
                </div>
            </div>
        );
    }

export default SondaggioElabPanel;